import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-5 gap-3" }
const _hoisted_2 = { class: "py-2 px-4 bg-next-gray-md" }
const _hoisted_3 = { class: "py-2 px-4 bg-next-gray-md" }
const _hoisted_4 = { class: "py-2 px-4 bg-next-gray-md" }
const _hoisted_5 = { class: "py-2 px-4 bg-next-gray-md" }
const _hoisted_6 = { class: "py-2 px-4 bg-next-gray-md" }
const _hoisted_7 = { class: "col-span-4" }
const _hoisted_8 = { class: "text-sm" }
const _hoisted_9 = { class: "text-sm inline mr-3" }
const _hoisted_10 = { class: "flex items-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiselectOption = _resolveComponent("MultiselectOption")!
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["p-3 border-b-2 border-next-gray-md mb-3", {'bg-green-100': _ctx.versione?.manual}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"text-sm font-bold\">Totale ricavi</div><div class=\"text-sm font-bold\">Totale costi</div><div class=\"text-sm font-bold\">Utile</div><div class=\"text-sm font-bold\">Margine</div><div class=\"text-sm font-bold\">Fees</div>", 5)),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.ActiveTab && _ctx.TotaleRicaviProgetto(_ctx.ActiveTab.sezioni) ? _ctx.TotaleRicaviProgetto(_ctx.ActiveTab.sezioni).toLocaleValueString() : '-'), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.ActiveTab && _ctx.TotaleCostiEuroProgetto(_ctx.ActiveTab.sezioni) ? _ctx.$filters.toEuroCurrency(_ctx.TotaleCostiEuroProgetto(_ctx.ActiveTab.sezioni)) : '-'), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.ActiveTab && _ctx.TotaleUtiliProgetto(_ctx.ActiveTab.sezioni).toLocaleValueString() ? `€ ${_ctx.TotaleUtiliProgetto(_ctx.ActiveTab.sezioni).toLocaleValueString()}` : '-'), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.ActiveTab && _ctx.TotaleMolFee(_ctx.ActiveTab.sezioni) ? `${_ctx.TotaleMolFee(_ctx.ActiveTab.sezioni).toLocaleValueString()} %` : '-'), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.ActiveTab && _ctx.TotaleFeesSezioni(_ctx.ActiveTab.sezioni) ? _ctx.$filters.toEuroCurrency(_ctx.TotaleFeesSezioni(_ctx.ActiveTab.sezioni)) : '-'), 1),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", _hoisted_8, [
          _cache[0] || (_cache[0] = _createElementVNode("i", { class: "icon icon-flag text-next-orange" }, null, -1)),
          _createTextVNode(" Versione " + _toDisplayString(_ctx.versione.major) + "." + _toDisplayString(_ctx.versione.minor) + " create da ", 1),
          _createElementVNode("b", null, _toDisplayString(_ctx.versione.created_by_label), 1),
          _createTextVNode(" il " + _toDisplayString(_ctx.$filters.toDate(_ctx.versione.created_at)) + " alle " + _toDisplayString(_ctx.$filters.toTime(_ctx.versione.created_at)), 1)
        ]),
        _withDirectives(_createElementVNode("p", _hoisted_9, [
          _cache[1] || (_cache[1] = _createElementVNode("i", { class: "icon icon-ferie_permessi" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.versione?.nota), 1)
        ], 512), [
          [_vShow, _ctx.versione?.nota]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag, i) => {
          return (_openBlock(), _createBlock(_component_MultiselectOption, {
            key: i,
            readonly: "1",
            class: "inline"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(tag), 1)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_NextButton, {
          variant: "outline-primary",
          component: "router-link",
          class: "p-2 w-full",
          to: {name:'DettaglioVersioneSottoProgetto', params:{id:_ctx.sottoprogetto.id, idv:_ctx.versione.id}}
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("Vedi offerta ")
          ])),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ], 2))
}